import { RouterProvider, Routes } from 'react-router-dom';
import Toast from '../../components/Toast';
import './styles.sass';
import BrowserRoutes from './routes';

const AppRouter = () => {
    return (
        <div className="app-wrap">
            <RouterProvider router={BrowserRoutes}>
                <Routes />
            </RouterProvider>
            <Toast />
        </div>
    );
};

export default AppRouter;
